import jwtDecode from 'jwt-decode';
import {
  APP_LOAD,
  REDIRECT,
  GOTOPAGE,
  LOGOUT,
  SETTINGS_SAVED,
  LOGIN,
  GOTOLOGIN,
  REGISTER,
  HOME_PAGE_UNLOADED,
  PROFILE_PAGE_UNLOADED,
  PROFILE_FAVORITES_PAGE_UNLOADED,
  SETTINGS_PAGE_UNLOADED,
  REGISTER_PAGE_UNLOADED, 
  SITE_SUBMITTED,
  SITE_UPDATED,
  DB_INITIALIZED
} from '../constants/actionTypes';
import { StaticRouter } from 'react-router';

const defaultState = {
  appName: 'Grace',
  token: null,
  viewChangeCounter: 0,
  isLocalDbGood: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case APP_LOAD:
      return {
        ...state,
        token: action.token || null,
        appLoaded: true,
        currentUser: action.payload.user,
        org: action.payload.org
      };
    case REDIRECT:
      return { ...state, redirectTo: null };
    case GOTOPAGE:
      return { ...state, redirectTo: action.payload };
    case LOGOUT:
      return { ...state, redirectTo: '/', token: null, currentUser: null };
    case GOTOLOGIN:
      return { ...state, redirectTo: '/login', appLoaded: true, token: null, currentUser: null };
    case DB_INITIALIZED:
      console.error('DB Initialized');
      return { ...state, isLocalDbGood: true };
    case SITE_SUBMITTED:
      return { ...state, redirectTo: `/sites/${action.payload.id}/view`};
    case SITE_UPDATED:
      if(action.payload.id) {
        return { ...state, redirectTo: `/sites/${action.payload.id}/view`};
      }else {
        return state;
      }
    case SETTINGS_SAVED:
      return {
        ...state,
        redirectTo: action.error ? null : '/',
        currentUser: action.error ? null : action.payload.user,
      };
    case LOGIN:
        return {
          ...state,
          redirectTo: (action.payload && action.payload.message) ? null : '/',
          token: action.payload.token || null,
          currentUser: action.payload.user,
          org: action.payload.org
        };
    case REGISTER:
      return {
        ...state,
      };
      // return {
      //   ...state,
      //   redirectTo: action.error ? null : '/',
      //   token: action.error ? null : action.payload.token,
      //   currentUser: action.error ? null : action.payload
      // };
    case HOME_PAGE_UNLOADED:
    case PROFILE_PAGE_UNLOADED:
    case PROFILE_FAVORITES_PAGE_UNLOADED:
    case SETTINGS_PAGE_UNLOADED:
    case REGISTER_PAGE_UNLOADED:
      return { ...state, viewChangeCounter: state.viewChangeCounter + 1 };
    default:
      return state;
  }
};
